import sendHttpGetRequest from "./sendHttpGetRequest";
import sendHttpPutRequest from "./sendHttpPutRequest";
import sendHttpPostRequest from "./sendHttpPostRequest";

const UserService = {
  getUsers: () => {
    return sendHttpGetRequest("/users/all");
  },

  uploadProfilePic: (formData) => {
    return fetch("users/user/uploadprofilepic", {
      method: "put",
      body: formData,
    }).then((res) => {
      if (res.status !== 401) {
        return res.json().then((data) => data);
      } else {
        return { message: { msgBody: "Unauthorized", msgError: true } };
      }
    });
  },
  getProfilePic: () => {
    return sendHttpGetRequest("/users/user/getprofilepic");
  },
  updateUserInfo: (userInfo) => {
    return sendHttpPutRequest(
      "users/user/updateuserinfo",
      JSON.stringify({
        object: userInfo,
      })
    );
  },

  updateUserPassword: (currentPassword, newPassword) => {
    return sendHttpPutRequest(
      "users/user/updateuserpassword",
      JSON.stringify({
        currentPassword: currentPassword,
        newPassword: newPassword,
      })
    );
  },
  updatePrivateResumeStatus: (privateResume) => {
    return sendHttpPutRequest(
      "users/user/updateprivateresumestatus",
      JSON.stringify(privateResume)
    );
  },
  getConsultant: () => {
    return sendHttpPostRequest("/users/user/getconsultant");
  },
};

export default UserService;
